import { getPhysicalRing } from 'owa-metatags';

const WHITELISTED_PHYSICAL_RINGS_SDS_IRIS_SUPPORT = ['Dogfood', 'MSIT', 'WW', 'SDFV2', 'SIP'];

/**
 * Utility function to denote whether SDS or IRIS should be used according to the Physical Ring of the user
 */
export const shouldUseSdsIris = () =>
    WHITELISTED_PHYSICAL_RINGS_SDS_IRIS_SUPPORT.indexOf(getPhysicalRing()) >= 0;
